// src/features/simulators/mobile-kiosk/components/MobileKioskSimulator.tsx

import React, { useState, useCallback } from 'react';
import { useTranslate } from 'react-admin';
import { TabletAndroid as MobileKioskIcon } from '@mui/icons-material';
import { SimulatorWizard } from '../../shared/components/SimulatorWizard';
import { useSimulatorWizard } from '../../shared/hooks/useSimulatorWizard';
import { MobileKioskConfigForm } from './MobileKioskConfigForm';
import { useMobileKioskSimulation } from '../hooks/useMobileKioskSimulation';
import { TerminalType } from '../types';
import { GuestType, KeyDeliveryMethod } from '../../shared/types/journey.types';
import type { MobileKioskConfigValues } from './MobileKioskConfigForm';

export const MobileKioskSimulator: React.FC = () => {
  const translate = useTranslate();
  const wizard = useSimulatorWizard({ deviceType: 'Mobile', channel: 'MobileKiosk' });
  const { simulate } = useMobileKioskSimulation();

  const [config, setConfig] = useState<MobileKioskConfigValues>({
    terminalType: TerminalType.MOBILE,
    guestType: GuestType.RESERVATION,
    keyDeliveryMethod: KeyDeliveryMethod.DIGITAL_MOBILE,
    reservationNumber: '',
    autoGenerateReservation: true,
  });

  const handleRun = useCallback(() => {
    wizard.runSimulation(async (client, addLog) => {
      return simulate(client, addLog, wizard.deviceId, wizard.hotelId, config);
    });
  }, [wizard, simulate, config]);

  return (
    <SimulatorWizard
      title={translate('resources.simulators.mobile_kiosk.title')}
      subtitle={translate('resources.simulators.mobile_kiosk.description')}
      icon={<MobileKioskIcon />}
      wizard={wizard}
      deviceType="Mobile"
      channel="MobileKiosk"
      configForm={
        <MobileKioskConfigForm
          values={config}
          onChange={setConfig}
        />
      }
      onRun={handleRun}
    />
  );
};

export default MobileKioskSimulator;
